import React from "react";
import PromptForm from "./components/PromptForm.jsx";

function App() {
  return <PromptForm />;
}

export default App;
